import { render } from "./module.vue?vue&type=template&id=fabf0fae"
import script from "./module.vue?vue&type=script&lang=js"
export * from "./module.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"dev/modules/theme/brands/module.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fabf0fae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fabf0fae', __exports__)) {
    api.reload('fabf0fae', __exports__)
  }
  
  module.hot.accept("./module.vue?vue&type=template&id=fabf0fae", () => {
    api.rerender('fabf0fae', render)
  })

}


export default __exports__